import SiteHeader from 'containers/SiteHeader'
import React, { ReactNode } from 'react'
import Footer from 'shared/Footer/Footer'

interface NoSearchEngineTemplateProps {
  children: ReactNode
}

export const NoSearchEngineTemplate: React.FC<NoSearchEngineTemplateProps> = ({
  children,
}) => {
  return (
    <>
      <SiteHeader searchEngine={false} />
      {children}
      <Footer />
    </>
  )
}
